<template>
  <div id="wangeditor">
    <div ref="editorElem" style="text-align:left;"></div>
  </div>
</template>
<script>
import E from "wangeditor";
export default {
  name: "Editor",
  data() {
    return {
      editorContent: ''
    };
  },
  mounted() {
    var editor = new E(this.$refs.editorElem)
        // editor.config.onchange = (html) => {
        //   this.editorContent = html
        //   console.log(this.editorContent)
         
        // }
        editor.config.onblur = (newHtml) => {
            console.log('onblur', newHtml) // 获取最新的 html 内容
            this.$emit('func',newHtml)
        }
    editor.config.menus = [
      // 菜单配置
      'head', // 标题
      'bold', // 粗体
      'fontSize', // 字号
      'italic',
      'underline',
      'indent',
      'lineHeight',
      'foreColor', // 文字颜色
      'justify', // 对齐方式
      'undo', // 撤销
      'redo' // 重复
    
    ];
    editor.create(); // 创建富文本实例
  }
}
</script>


// WEBPACK FOOTER //
// src/test/upload_426/component/editor.vue